<template>
    <v-container fluid>
        <v-alert
            ref="alert"
            v-show="warningText"
            type="warning"
        >
            {{warningText}}
        </v-alert>
        <v-row>
            <v-col cols="12" lg="3">
                <v-card class="px-3 pb-3">
                    <v-card-title>Search form 
                        <iupac-tooltip>
                            To search the datasheets choose the input type between name, InChI, SMILES or formula. Then select a suggested compound or input a pattern (if search mode is equal to partial match). Finally click on search button to submit the form. <br>The compound(s) searched will be indicated under the form. Results will be displayed in a table. You can select and unselect compound to refine your search.<br>N.B. : Only InChI and SMILES are case sensitive.
                        </iupac-tooltip>
                    </v-card-title>
                    <v-select label="Search by" v-model="filter" :items="['name', 'formula', 'SMILES', 'InChI']"></v-select>
                    <molecule-selector
                        ref="MoleculeSelector"
                        v-show="!isPattern"
                        v-on:get-molecules="search($event)"
                        v-bind:molecules="molecules"
                        v-bind:filter="filter"
                    ></molecule-selector>
                    <molecule-pattern
                        ref="PatternSelector"
                        v-show="isPattern"
                        v-on:get-molecules="search($event)"
                        v-bind:molecules="molecules"
                        v-bind:filter="filter"
                    ></molecule-pattern>
                    <reaction-side-selector 
                        v-bind:reaction-side.sync="reactionSide"
                        v-on:update:reaction-side="fetchMolecules"
                    >
                        Reactants and/or Products
                        <iupac-tooltip>
                            You can refine your search by targeting the side of the reaction.
                        </iupac-tooltip>
                    </reaction-side-selector>
                    <search-mode-selector
                        v-bind:is-pattern.sync="isPattern"
                    >
                        Search mode 
                        <iupac-tooltip>
                            You can search a molecule's name by pattern. Example : "Hydrogen" could have several outputs.<br>Hydrogen, atom hydrogen, hydrogen fluoride, ...
                        </iupac-tooltip>
                    </search-mode-selector>
                    <v-btn @click="submit">search</v-btn>
                </v-card>
            </v-col>
            <v-col cols="12" lg="9">
                <v-card class="mb-3">
                    <v-card-title>Selected {{reactionSide}} ({{subSelectedMolecules.length}})</v-card-title>
                    <selectable-molecules 
                        v-bind:selected-molecules="selectedMolecules"
                        v-on:get-molecules="refineSearch($event)"
                    ></selectable-molecules>
                </v-card>
                <v-card>
                    <v-card-title>Selected datasheets ({{datasheets.length}})</v-card-title>
                    <datasheets-table
                        v-if="datasheets.length>0"
                        v-bind:datasheets="datasheets"
                    ></datasheets-table>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import MoleculeSelector from './MoleculeSelector.vue';
import MoleculePattern from './MoleculePattern.vue';
import ReactionSideSelector from './ReactionSideSelector.vue';
import DatasheetsTable from './DatasheetsTable.vue';
import SearchModeSelector from './SearchModeSelector.vue';
import SelectableMolecules from './SelectableMolecules.vue';
import IupacTooltip from './IupacTooltip.vue';

var noMoleculeWarning = "No molecule find for the last sumited search form.";
var noDatsheetWarning = "No datasheet available for the selected molecules.";
export default {
    name: "NewSearch",
    components: {
        MoleculeSelector,
        MoleculePattern,
        ReactionSideSelector,
        DatasheetsTable,
        SearchModeSelector,
        SelectableMolecules,
        IupacTooltip,
    },
    data:
        function() {
            return {
                molecules: [],
                selectedMolecules: [],
                subSelectedMolecules: [],
                datasheets: [],
                filter: 'name',
                reactionSide: 'molecules',
                isPattern: false,
                warningText: ""
            }
        }
    ,
    created() {
        this.fetchMolecules();
    },
    methods: {
        submit() {
            // clear last request's responses.
            this.selectedMolecules = [];
            this.subSelectedMolecules = [];
            this.datasheets = [];
            this.warningText = "";
            if(this.isPattern) {
                this.$refs.PatternSelector.find();
            }else{
                this.$refs.MoleculeSelector.find();
            }
        },
        search(molecules) {
            if(molecules.length===0) {
                this.warningText = noMoleculeWarning;
            }else{
                this.selectedMolecules = molecules;
                this.subSelectedMolecules = molecules;
                this.fetchDatasheets(molecules);
            }
        },
        refineSearch(molecules) {
            if(molecules.length===0) {
                this.warningText = noMoleculeWarning;
                this.subSelectedMolecules = molecules;
                this.datasheets = [];
            }else{
                this.subSelectedMolecules = molecules;
                this.fetchDatasheets(molecules);
            }
        },
        fetchMolecules() {
            let promise;
            if(this.reactionSide==='molecules') {
                promise = this.axios.get(this.reactionSide)
            }else{
                promise = this.axios.get(this.reactionSide+'/molecules')
            }
            promise.then(response => {
                this.molecules = response.data
            });
        },
        fetchDatasheets(molecules) {
            let inchikeys = molecules.map(molecule => molecule['inchikey']);
            let url = this.reactionSide+'/'+inchikeys.join(",")+'/datasheets';
            let promise = url.length>255 ? this.fetchDatasheetsPost(molecules) : this.fetchDatasheetsGet(url);
            promise.then(response => {
                if(response.data.length>0) {
                    this.warningText = "";
                    this.datasheets = response.data;
                }else{
                    this.datasheets = [];
                    this.warningText = noDatsheetWarning;
                }
            })
            .catch(error => {
                console.log(error)
                this.errored = true
            })
            .finally(() => this.loading = false);
        },
        fetchDatasheetsGet(url) {
            return this.axios.get(url);
        },
        fetchDatasheetsPost(molecules) {
            return this.axios.post(this.reactionSide+'/datasheets', molecules);
        }
    }
}
</script>